// extracted by mini-css-extract-plugin
var _1 = "BotCard-modulecard__Y1t4u";
var _2 = "BotCard-moduleplaceholder__Tdycd";
var _3 = "BotCard-moduletext__jOO4I";
export { _1 as "card", _2 as "placeholder", _3 as "text" }
